/* eslint-disable no-shadow */
import sessionService from "../service/session.service";
import commonHelper from "../helpers/common";

const state = {
  isLoading: false,
  lastQuery: null,
  data: [],
  metaData: {},
  error: false,
};

const actions = {
  clearAll({ commit }) {
    commit("SET_DATA", {});
    commit("SET_LOADING", false);
    commit("SET_ERROR", false);
  },

  async getByUniqId({ commit }, id) {
    commit("SET_LOADING", true);
    await sessionService.getByUniqId(id).then((response) => {
      commit("SET_DATA", response);
      commit("SET_LOADING", false);
    });
  },
  async update({ commit }, payload) {
    commit("SET_LOADING", true);
    await sessionService.update(payload).then((response) => {
      commit("SET_LOADING", false);
    });
  },
  async moveTable({ commit }, payload) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", false);
    await sessionService
      .moveTable(payload)
      .then((response) => {
        commit("SET_LOADING", false);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        // A network-level failure has no response, so there is no errors
        // payload to show. Commit a plain truthy flag in that case: the
        // component falls back to a generic message rather than throwing on
        // a field that is not there.
        const response = error && error.response;
        const errors = response && response.data && response.data.errors;
        commit("SET_ERROR", errors || true);
      });
  },
};

const mutations = {
  SET_DATA(state, data) {
    state.data = data;
  },
  SET_ERROR(state, data) {
    state.error = data;
  },
  SET_META_DATA(state, data) {
    state.metaData = data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  CLEAR(state) {
    state.data = null;
  },
};

// state.data starts as [] and is {} after clearAll, so expired_at is absent
// until the session request resolves. Returning it only when it is really
// there keeps "not loaded yet" from being judged as "expired".
function sessionExpiredAt(state) {
  const { data } = state;
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return null;
  }
  return data.expired_at === undefined ? null : data.expired_at;
}

const getters = {
  getOrderRounds(state) {
    const { data } = state;
    if (!data || typeof data !== "object" || Array.isArray(data) || !data.order) {
      return [];
    }
    return data.order.order_rounds;
  },
  getNotOrderRounds(state) {
    return [];
  },
  // null means "we do not know yet" -- callers must not treat that as expired.
  // PMain compares with === true precisely so an unresolved session cannot
  // raise the expired banner.
  getIsExpired(state) {
    const expiredAt = sessionExpiredAt(state);
    if (expiredAt === null) {
      return null;
    }
    return commonHelper.checkIsExpired(expiredAt);
  },
  // null for "unknown"; Redirect.vue already renders its waiting state on null.
  getRemainSecondBeforeExpired: (state) => () => {
    const expiredAt = sessionExpiredAt(state);
    if (expiredAt === null) {
      return null;
    }
    return commonHelper.getDiffSecond(expiredAt);
  },
};

const session = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default session;
